export default "__VITE_ASSET__CgX3UMPc__"